/**
 * Mapeo de nombres de campo (backend) a etiquetas legibles para mostrar en toasts de error.
 */
export const PRODUCT_FIELD_LABELS: Record<string, string> = {
    name: 'Nombre',
    productTypeId: 'Tipo de producto',
    code: 'Código de Acción Formativa',
    amount: 'Importe',
    workersRangePriceEnabled: 'Precio por rango de trabajadores',
    workersRangePrices: 'Rangos de trabajadores',
    cost: 'Coste',
    contractTemplate: 'Plantilla de contrato',
    weeklyHours: 'Horas semanales',
    providingCorporations: 'Empresas impartidoras',
    score: 'Puntuación',
    penaltyScore: 'Puntuación de penalización',
    renewalSettings: 'Configuración de renovación',
    renewalDaysNumber: 'Días antes de la renovación',
    complements: 'Complementos',
    inspectorUser: 'Usuario del inspector',
    inspectorPassword: 'Contraseña del inspector',
    description: 'Descripción',
    trainingActionGroupId: 'Grupo de acciones formativas',
    professionalAreaId: 'Área profesional',
    trainingModalityId: 'Modalidad',
    presentialHours: 'Horas presenciales',
    teleformHours: 'Horas de teleformación',
    actionType: 'Tipo de acción',
    trainingLevel: 'Nivel formativo',
    objectives: 'Objetivos',
    contents: 'Contenidos',
    organisingCorporationsPlatformData: 'Datos de plataforma por organizadora',
    platformCif: 'CIF plataforma',
    platformBusinessName: 'Razón social plataforma',
    platformUrl: 'URL plataforma',
};

export const PRODUCT_TYPE_FIELD_LABELS: Record<string, string> = {
    name: 'Nombre',
    description: 'Descripción',
    renewalSettings: 'Configuración de renovación',
    renewalDaysNumber: 'Días antes de la renovación',
    contractTemplate: 'Plantilla de contrato',
    consultancyFieldsRequired: 'Campos de asesoría obligatorios',
    templateConceptClientInvoice: 'Concepto factura cliente',
    templateConceptTutorInvoice: 'Concepto factura tutor',
    templateConceptInternalInvoice: 'Concepto factura interna',
};

/**
 * Formatea un error de validación mostrando el campo y el mensaje.
 */
export function formatValidationError(error: { property?: string; message: string }, fieldLabels?: Record<string, string>): string {
    const field = error.property;
    const message = error.message;
    if (field && fieldLabels?.[field]) {
        return `${fieldLabels[field]}: ${message}`;
    }
    if (field) {
        return `${field}: ${message}`;
    }
    return message;
}
